<template>
  <div class="full"><router-view></router-view></div>
</template>

<script>
export default {

}
</script>

<style>

</style>